import { motion } from 'framer-motion'

const technologies = ['React', 'Node.js', 'MongoDB', 'Tailwind', 'Firebase', 'Next.js']

const Services = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-violet-950 to-slate-900 px-6 py-28 text-white">
      <div className="mx-auto max-w-7xl">

        <h1 className="text-center text-5xl font-black md:text-7xl">
          Website
          <span className="bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text text-transparent"> Development</span>
        </h1>

        <div className="mt-24 grid gap-8 md:grid-cols-3">
          {technologies.map((tech, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05, rotate: 1 }}
              className="rounded-3xl border border-violet-500/20 bg-white/10 p-10 text-center backdrop-blur-xl"
            >
              <h2 className="text-3xl font-bold">{tech}</h2>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Services